<template>
  <scroll-bar>
    <el-menu mode="vertical"  :default-active="$route.path" :collapse="isCollapse" background-color="#304156"
             text-color="#bfcbd9" active-text-color="#409EFF">
      <div class="app-name" v-if="opened">新时代回收供销再生资源</div>
      <div v-else class="logo_box">
        <img src="../../../../assets/logo_.png" alt="新时代回收供销再生资源" class="logo_" title="新时代回收供销再生资源">
      </div>
      
      <!--<span>我是左边</span>-->
      <sidebar-item :routes="permission_routers"></sidebar-item>
      <!--<sidebar-item></sidebar-item>-->
    </el-menu>
  </scroll-bar>
</template>

<script>
  import {mapGetters} from 'vuex'
  import SidebarItem from './SidebarItem'
  import ScrollBar from '@/components/ScrollBar'

  export default {
    props:['opened'],
    components: {SidebarItem, ScrollBar},
    computed: {
      ...mapGetters([
        'permission_routers',
        'sidebar'
      ]),
      isCollapse() {
        return !this.sidebar.opened
      }
    }
  }
</script>
<style scoped>
  .app-name{
    text-align:center;
    color: rgb(191, 203, 217);
    height: 49px;
    line-height: 49px;
    background: #293039;
    font-size: 15px;
    /* border-bottom: solid 1px #e6e6e6; */
  }
  .logo_box{
    text-align: center;
    height: 49px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #293039;
  }
  .logo_{
    width: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue